import './mock/index.test';

// export * from './core';
// export * from './define/api-v1';
export * from './impl/api-v1';
export { setBaseUrl, initRequestClient } from './core';
